module.exports = __webpack_public_path__ + "img/landing-img.ff06e866.jpg";